// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"485d1524","787":"f216ee4f","983":"ebb4e941"}[chunkId] + ".chunk.js";
};